export enum Ticket {
	Index = 'ticket.index',
	Create = 'ticket.create',
	Show = 'ticket.show',
	SendMessage = 'ticket.send_message',
	Close = 'ticket.close',
	Delete = 'ticket.delete',
	DepartmentRole = 'ticket.department_role',
}
